export default "c8f2e1ed5f826175.svg"